import { inject } from "@angular/core";
import { HttpInterceptorFn } from "@angular/common/http";
import { InterceptorManagerService } from "src/app/interceptors/interceptor-manager.service";

export const dynamicInterceptorBridgeFn: HttpInterceptorFn = (req, next) =>
  inject(InterceptorManagerService).run(req, next);
